<template>
  <v-row dense class="mt-1">
    <v-col cols="12" sm="6" md="4">
      <div class="objection-field__label">Manifestado em</div>
      <div class="objection-field__value">{{ $moment(record.answered_at).format('DD/MM/YYYY') }}{{ record.answered_by === 'lawyer' ? ' (procurador)' : '' }}</div>
    </v-col>
    <v-col v-if="record.amount" cols="12" sm="6" md="4">
      <div class="objection-field__label">Valor com o qual concorda</div>
      <div class="objection-field__value objection-field__value--amount">{{ money(record.amount) }}</div>
    </v-col>
    <v-col cols="12">
      <div class="objection-field__label">Justificativa</div>
      <div class="objection-field__text">{{ record.reason }}</div>
    </v-col>
    <v-col v-if="record.docs && record.docs.length" cols="12">
      <div class="objection-field__label">Documentos</div>
      <v-btn v-for="doc in record.docs" :key="doc.key" :href="doc.url" :disabled="!doc.url" target="_blank" rel="noopener noreferrer"
        small outlined color="primary" class="mr-2 mt-1"><v-icon left small>mdi-file-document-outline</v-icon>{{ doc.name }}</v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'ManifestationFields',
  props: { record: { type: Object, required: true } },
  methods: {
    money(value) { return Number(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); },
  },
};
</script>
